export default __webpack_public_path__ + "static/media/delete-icon.71d44609.svg";